<template>
  <div class="pg-scan-area">
    <PgTabs
      class="pg-scan-area__tag"
      :hideHeader="hideHeader"
      v-model="active"
      @tab-click="switchTab"
    >
      <PgTabPane
        class="pg-scan-area__tag-udi"
        :class="{ 'pg-scan-area__tag-udi--hide-control': hideControl }"
        label="普通添加"
        name="UDI"
      >
        <div class="pg-scan-area__udi-top">
          <PgInputScan
            class="pg-scan-area__udi-top-scan"
            ref="udiInputRef"
            v-popover:popoverRef
            :placeholder="placeholder"
            :disabled="scanDisabled || disabled"
            @on-focus="inputFocus"
            @on-scan="onScanEvent"
            @on-auto="confirm"
          />
          <span class="pg-scan-area__udi-top-type" v-show="scanType">{{ scanType }}</span>
          <div class="pg-scan-area__udi-top-analysis">
            <div
              class="pg-scan-area__udi-top-analysis-item"
              v-for="(item, index) in showScanAnalysis"
              :key="index"
            >
              <span class="pg-scan-area__udi-top-analysis-title">{{ item.label }}</span>
              <span class="pg-scan-area__udi-top-analysis-value">{{ item.value }}</span>
            </div>
          </div>
          <span class="pg-scan-area__udi-top-error" :title="tipText">{{ tipText }}</span>
          <div class="pg-scan-area__udi-top-operation" v-if="!hideControl && !scanAreaFormPopover">
            <!-- <ElButton type="text" >设置商品扫码属性</ElButton>
            <ElButton class="pg-scan-area__udi-top-operation-print" type="text"
              >打印条码</ElButton
            > -->
            <PgButtonGroup type="text" :list="buttonList"></PgButtonGroup>
            <div class="pg-scan-area__udi-top-operation-auto">
              <span class="pg-scan-area__udi-top-operation-auto-text">自动确认</span>
              <ElSwitch v-model="autoConfim" @change="autoConfimChange"> </ElSwitch>
            </div>
          </div>
        </div>
        <Popover
          v-if="scanAreaFormPopover"
          ref="popoverRef"
          popper-class="pg-scan-area-popover"
          placement="bottom-start"
          trigger="click"
          v-model="popoverVisible"
        >
          <scanAreaForm
            v-if="!hideControl"
            ref="formRef"
            class="pg-scan-area__tag-content"
            :formSize="formSize"
            :extendData="extendData"
            :formData="formData"
            :customFormItems="customFormItems"
            :formItemsCode="formItemsCode"
            :autoConfim="autoConfim"
            :reset="reset"
            :confirm="confirm"
          >
            <div class="pg-scan-area__udi-top-operation">
              <PgButtonGroup type="text" :list="buttonList"></PgButtonGroup>
              <div class="pg-scan-area__udi-top-operation-auto">
                <span class="pg-scan-area__udi-top-operation-auto-text">自动确认</span>
                <ElSwitch v-model="autoConfim" @change="autoConfimChange"> </ElSwitch>
              </div>
            </div>
          </scanAreaForm>
        </Popover>
        <scanAreaForm
          v-if="!hideControl && !scanAreaFormPopover"
          ref="formRef"
          class="pg-scan-area__tag-content"
          :formSize="formSize"
          :extendData="extendData"
          :formData="formData"
          :customFormItems="customFormItems"
          :formItemsCode="formItemsCode"
          :autoConfim="autoConfim"
          :reset="reset"
          :confirm="confirm"
        />
        <!-- <div class="pg-scan-area__tag-content" v-if="!hideControl">
          <PgForm
            class="pg-scan-area__tag-form"
            :class="{ 'pg-scan-area__tag-form--medium': formSize === 'medium' }"
            ref="formRef"
            :extendCompileData="extendData"
            :model="formData"
            :formItems="customFormItems"
            :formItemsCode="formItemsCode"
          ></PgForm>
          <div class="pg-scan-area__tag-operation">
            <img
              :class="{ 'pg-scan-area__tag-autoConfim__disabled': autoConfim }"
              class="scan-img"
              src="../../../static/image/scanSave.png"
            />
            <div class="pg-scan-area__tag-operation-button">
              <ElButton type="danger" round @click="reset">重置</ElButton>
              <ElButton style="width: 90px" type="primary" round @click="confirm">确认</ElButton>
            </div>
          </div>
        </div> -->
      </PgTabPane>
      <!-- <PgTabPane class="pg-scan-area__tag-epc" label="自定义序列号添加" name="EPC" lazy>
        自定义序列化添加
      </PgTabPane> -->
    </PgTabs>
  </div>
</template>
<script setup>
import { PgTabs, PgTabPane } from '../../tabs/index'
import { PgInputScan } from '../../input-scan/index'
import { PgButtonGroup } from '../../button-group/index'
import { BUTTONGROUP } from '../../../tokens/index'
import { ref, computed, inject, toRef } from 'vue'
import { Popover } from 'element-ui'
import { useScanUdiArea } from '../hook/use-scan-udi-area'
import scanAreaForm from './scan-area-form.vue'

const props = defineProps({
  setGood: {
    type: Boolean,
    default: false,
  },
  printScan: {
    type: Boolean,
    default: false,
  },
  showScanAnalysisKeys: {
    type: Array,
    default: () => [
      'productIdent',
      'batchNumber',
      'periodBegin',
      'periodEnd',
      'periodExpire',
      'serialNumber',
      'amount',
    ],
  },
  //表单额外参数
  extendData: Object,
  formItemsCode: String,
  formItems: [Array, Object],
  getGoodsUrl: {
    type: String,
    default: 'rest/ezscc/scan/scanAllGoods',
  },
  getGoodsParam: Object,
  //扫码后的回调函数
  scanAfter: Function,
  //确认
  onConfirm: Function,
  buttonKey: {
    type: String,
    default: 'SET_GOODS',
  },
  hideHeader: Boolean,
  formSize: String,
  // 是否自动将未识别到的码设置为epc
  autoEpc: Boolean,
  // scanAllGoods 未获取到商品时，依然可以确认提交
  forceConfirm: Boolean,
  // 是否使用缓存中的自动确认，当配置此属性时，是否自动确认都以此字段为准
  useAutoConfim: {
    type: Boolean,
    default: undefined,
  },
  // 是否隐藏控制按钮
  hideControl: Boolean,
  //  批量扫码 可取值 gs1/trace 当为trace时，会将扫的码放在请求接口参数的traceCodes字段中
  batchScan: String,
  batchTime: {
    type: Number,
    default: 200,
  },
  placeholder: String,
  disabled: Boolean,
  // 扫码结果是否使用浮出窗样式
  scanAreaFormPopover: Boolean,
})

const { getButtonByKey } = inject(BUTTONGROUP, {
  getButtonByKey: (val) => (Array.isArray(val) ? val : []),
})
const buttonList = getButtonByKey(props.buttonKey)

const active = ref('UDI')
const switchTab = (val) => {
  active.value = val
}

const popoverRef = ref(null)
const popoverVisible = ref(false)
const showPopover = () => {
  popoverVisible.value = true
}
const inputFocus = () => {
  udiInputRef.value?.select()
}
const onScanEvent = (...arg) => {
  showPopover()
  onScan(...arg)
}

const {
  udiInputRef,
  formRef,
  scanType,
  scanDisabled,
  onScan,
  formData,
  autoConfim,
  autoConfimChange,
  showScanAnalysis,
  tipText,
  reset,
  confirm,
} = useScanUdiArea({
  showScanAnalysisKeys: props.showScanAnalysisKeys ?? [],
  getGoodsUrl: props.getGoodsUrl,
  scanAfter: props.scanAfter,
  onConfirm: props.onConfirm,
  getGoodsParam: toRef(props, 'getGoodsParam'),
  autoEpc: props.autoEpc,
  forceConfirm: props.forceConfirm,
  useAutoConfim: props.useAutoConfim,
  extendData: toRef(props, 'extendData'),
  batchScan: props.batchScan,
  batchTime: props.batchTime,
  popoverVisible,
})
const customFormItems = computed(() => {
  return Array.isArray(props.formItems)
    ? {
        form: {
          property: {
            colNum: 7,
            colWidth: 180,
            formGroup: false,
          },
        },
        items: props.formItems,
      }
    : props.formItems
})
</script>
<style lang="scss">
@import '../style/scan-area.scss';
</style>
